import { render, staticRenderFns } from "./VirtualScrollResults.vue?vue&type=template&id=56a0d0f1&scoped=true"
import script from "./VirtualScrollResults.vue?vue&type=script&lang=ts"
export * from "./VirtualScrollResults.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScrollResults.vue?vue&type=style&index=0&id=56a0d0f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0d0f1",
  null
  
)

export default component.exports